import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Page from '@atlaskit/page';
import StarterNavigation from '../components/StarterNavigation';
import {connect} from 'react-redux';
import SearchActions from '../redux/SearchRedux';
import AuthActions from '../redux/AuthRedux';
import LanguageActions from '../redux/LanguageRedux';
import Forbidden from '../components/Forbidden';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flags: [],
      isModalOpen: false,
    };
  }

  componentDidMount() {
    if (!this.props.userProfile.userRole) {
      //this.props.getUserProfile();
    }
  }

  static contextTypes = {
    navOpenState: PropTypes.object,
    router: PropTypes.object,
  };

  static propTypes = {
    navOpenState: PropTypes.object,
    onNavResize: PropTypes.func,
  };

  static childContextTypes = {
    showModal: PropTypes.func,
    addFlag: PropTypes.func,
  }

  getChildContext() {
    return {
      //showModal: this.showModal,
      //addFlag: this.addFlag,
    };
  }

  render() {
    const {
      search,
      globalSearch,
      userProfile,
      client,
      signOut,
      currentLang,
      langs,
      changeLang,
    } = this.props;

    return (
        <Page
          navigationWidth={this.context.navOpenState.width}
          navigation={
            <StarterNavigation
              search={search}
              getSearch={globalSearch}
              userProfile={userProfile}
              clientProfile={client}
              signOut={signOut}
              currentLang={currentLang}
              langs={langs}
              changeLang={changeLang}
            />
          }
        >
          {userProfile.id ? this.props.children : (userProfile.error && <Forbidden action={signOut}/>)}
        </Page>
    );
  }
}

const mapStateToProps = state => {
  return {
    msgs: state.messages.data,
    search: state.search,
    userProfile: state.userProfile,
    client: state.client,
    currentLang: state.language.current,
    langs: state.language.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    globalSearch: query => dispatch(SearchActions.searchRequest(true, query)),
    //getUserProfile: () => dispatch(UserProfileActions.userProfileRequest()),
    signOut: () => dispatch(AuthActions.logoutRequest()),
    changeLang: id => dispatch(LanguageActions.languageChangeRequest(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);